var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEffect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 139,
    viewBox: "0 0 151 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35938 4.18199H10.7207V5.90399H6.35938V10.4304H4.36133V5.90399H0V4.18199H4.36133V0H6.35938V4.18199Z",
    fill: "#FF7152"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35938 36.2424H10.7207V37.9644H6.35938V42.4908H4.36133V37.9644H0V36.2424H4.36133V32.0605H6.35938V36.2424Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.35938 68.3029H10.7207V70.0249H6.35938V74.5513H4.36133V70.0249H0V68.3029H4.36133V64.1209H6.35938V68.3029Z",
    fill: "#E5E5E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3594 4.18199H45.7207V5.90399H41.3594V10.4304H39.3613V5.90399H35V4.18199H39.3613V0H41.3594V4.18199Z",
    fill: "#E5E5E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3594 36.2424H45.7207V37.9644H41.3594V42.4908H39.3613V37.9644H35V36.2424H39.3613V32.0605H41.3594V36.2424Z",
    fill: "#E5E5E5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3594 68.3029H45.7207V70.0249H41.3594V74.5513H39.3613V70.0249H35V68.3029H39.3613V64.1209H41.3594V68.3029Z",
    fill: "#E5E5E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3594 100.363H45.7207V102.085H41.3594V106.612H39.3613V102.085H35V100.363H39.3613V96.1813H41.3594V100.363Z",
    fill: "#E5E5E5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3594 4.18199H80.7207V5.90399H76.3594V10.4304H74.3613V5.90399H70V4.18199H74.3613V0H76.3594V4.18199Z",
    fill: "#E5E5E5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3594 36.2424H80.7207V37.9644H76.3594V42.4908H74.3613V37.9644H70V36.2424H74.3613V32.0605H76.3594V36.2424Z",
    fill: "#E5E5E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3594 68.3029H80.7207V70.0249H76.3594V74.5513H74.3613V70.0249H70V68.3029H74.3613V64.1209H76.3594V68.3029Z",
    fill: "#6246E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3594 100.363H80.7207V102.085H76.3594V106.612H74.3613V102.085H70V100.363H74.3613V96.1813H76.3594V100.363Z",
    fill: "#E5E5E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3594 132.424H80.7207V134.146H76.3594V138.672H74.3613V134.146H70V132.424H74.3613V128.242H76.3594V132.424Z",
    fill: "#E5E5E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M111.359 4.18199H115.721V5.90399H111.359V10.4304H109.361V5.90399H105V4.18199H109.361V0H111.359V4.18199Z",
    fill: "#E5E5E5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M111.359 36.2424H115.721V37.9644H111.359V42.4908H109.361V37.9644H105V36.2424H109.361V32.0605H111.359V36.2424Z",
    fill: "#E5E5E5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M111.359 68.3029H115.721V70.0249H111.359V74.5513H109.361V70.0249H105V68.3029H109.361V64.1209H111.359V68.3029Z",
    fill: "#E5E5E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M111.359 100.363H115.721V102.085H111.359V106.612H109.361V102.085H105V100.363H109.361V96.1813H111.359V100.363Z",
    fill: "#E5E5E5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.359 132.424H115.721V134.146H111.359V138.672H109.361V134.146H105V132.424H109.361V128.242H111.359V132.424Z",
    fill: "#E5E5E5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M146.359 4.18199H150.721V5.90399H146.359V10.4304H144.361V5.90399H140V4.18199H144.361V0H146.359V4.18199Z",
    fill: "#E5E5E5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M146.359 36.2424H150.721V37.9644H146.359V42.4908H144.361V37.9644H140V36.2424H144.361V32.0605H146.359V36.2424Z",
    fill: "#E5E5E5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M146.359 68.3029H150.721V70.0249H146.359V74.5513H144.361V70.0249H140V68.3029H144.361V64.1209H146.359V68.3029Z",
    fill: "#E5E5E5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M146.359 100.363H150.721V102.085H146.359V106.612H144.361V102.085H140V100.363H144.361V96.1813H146.359V100.363Z",
    fill: "#E5E5E5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146.359 132.424H150.721V134.146H146.359V138.672H144.361V134.146H140V132.424H144.361V128.242H146.359V132.424Z",
    fill: "#E5E5E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffect);
export default __webpack_public_path__ + "static/media/effect.cfb266b1b3a88f67e2ac562705f4b411.svg";
export { ForwardRef as ReactComponent };